import React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  api_auth,
  api_host,
  CLIENTE_ID_PICHINCHA,
  TOKEN_USR_DASHBOARD_PICHINCHA,
  USR_DASHBOARD_PICHINCHA,
} from '../../../common/globals/constants';
import { useObjectivesList } from '../../../hooks/useObjectivesList';

const HASH = '3276bd408a114308ab00c6133fe29fb2';

export function useObjetivosPichincha() {
  /** Obtener listado de objetivos del usuario */
  const {
    data: listadoObjetivos,
    isLoading: isLoadingObjectiveList,
  } = useObjectivesList({ fromStorage: true });

  /** Obtener listado de objetivos del usuario dashboard Pichincha */
  const {
    data: listadoObjetivosPichincha,
    isLoading: isLoadingObjectiveListPichincha,
  } = useQuery({
    queryKey: ['objetivos-pichincha'],
    queryFn: async () => {
      const params = new URLSearchParams({
        key: api_auth,
        token: TOKEN_USR_DASHBOARD_PICHINCHA,
        clienteId: CLIENTE_ID_PICHINCHA,
        clienteUsuarioId: USR_DASHBOARD_PICHINCHA,
        hash: HASH,
      });
      const url = `${api_host}/reporte/online/indicadores/getClienteInfo/?${params.toString()}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`getClienteInfo failed: ${response.status}`);
      }
      const data = await response.json();
      return data.objetivos ?? [];
    },
  });

  const objectivesToDisplay = React.useMemo(() => {
    if (isLoadingObjectiveList) {
      return [];
    }
    if (isLoadingObjectiveListPichincha) {
      return [];
    }

    // Filtrar los objetivos para mostrar solo aquellos que están en ambos listados
    return listadoObjetivos.filter((item) =>
      listadoObjetivosPichincha.find(
        (objetivo) => objetivo.objetivo_id === item.objetivo_id,
      ),
    );
  }, [
    listadoObjetivos,
    listadoObjetivosPichincha,
    isLoadingObjectiveList,
    isLoadingObjectiveListPichincha,
  ]);

  return {
    isLoading: isLoadingObjectiveList || isLoadingObjectiveListPichincha,
    data: objectivesToDisplay,
  };
}
